

<div class="padding-top-10">
	<button class="btn btn-info btn-purchasenewpack" (click)="addNewClientType()">Add New Client Type</button>
</div>
<br>

<ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
</ngx-spinner>

<ngx-datatable #priceDataTable
			   class='material striped datatable'
			   [rows]='clientTypes'
			   [columnMode]='"force"'
			   [headerHeight]='40'
			   [footerHeight]='20'
			   [scrollbarV]="true"
			   [rowHeight]="40"
			   [reorderable]="true"
			   [messages]="{emptyMessage:'Nothing to see here'}">						

	<ngx-datatable-column prop="name" [sortable]="true">
		<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
			<span (click)="sort()" >
				Client Type / Code
			</span>
		</ng-template>
		<ng-template let-row="row" ngx-datatable-cell-template >
			{{row.name}} / {{row.code}}
		</ng-template>
	</ngx-datatable-column>  		   
		
	<ngx-datatable-column prop="organizationName" [sortable]="true">
		<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
			<span (click)="sort()" >
				Organizations
			</span>
		</ng-template>
		<ng-template let-row="row" ngx-datatable-cell-template >
			{{row.organizationName}}
		</ng-template>
	</ngx-datatable-column>  

	<ngx-datatable-column prop="product" [sortable]="true" [width]="300">
		<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
			<span (click)="sort()" >
				Actions
			</span>
		</ng-template>
		<ng-template let-row="row" ngx-datatable-cell-template >
			<button type="button" (click)="editClientType(row.clientTypeId)">Edit</button>
			<!--<button type="button"  (click)="deleteClientType(row.clientTypeId)">Delete</button>-->
		</ng-template>
	</ngx-datatable-column>	

</ngx-datatable>


				

							
				 
